(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["b2b-restock-request"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.b2b-rr__toggle');
      if (!t) return;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.b2b-rr__form');
      if (!form) return;
      e.preventDefault();
      var box = form.closest('.b2b-rr');
      var status = box.querySelector('.b2b-rr__status');
      var qty = Number(form.elements.qty.value);
      if (!(qty >= 1)) { form.elements.qty.focus(); status.textContent = box.dataset.error; return; }
      var button = form.querySelector('button[type="submit"]');
      button.disabled = true; status.textContent = '';
      fetch(box.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: form.elements.email.value, qty: qty, handle: box.dataset.handle, website: form.elements.website.value })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && j.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok) { status.textContent = box.dataset.success; form.hidden = true; box.querySelector('.b2b-rr__note').hidden = true; }
          else { status.textContent = box.dataset.error; button.disabled = false; }
        })
        .catch(function () { status.textContent = box.dataset.error; button.disabled = false; });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["b2b-sample-button"] && !Shopify.designMode) return;
  try {
    (function () {
    // one listener for the whole page, so it keeps working when the product section is refreshed after a choice of packaging
    if (window.b2bSampleReady) return;
    window.b2bSampleReady = true;
    function shut(panel) {
      panel.hidden = true;
      var btn = panel.parentElement.querySelector('.b2b-sample__open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('.b2b-sample__open');
      document.querySelectorAll('.b2b-sample__panel:not([hidden])').forEach(function (p) {
        var sameBox = open && open.closest('.b2b-sample') === p.closest('.b2b-sample');
        if (!p.contains(e.target) && !sameBox) shut(p);
      });
      if (open) {
        var panel = open.closest('.b2b-sample').querySelector('.b2b-sample__panel');
        if (!panel) return;
        var wasOpen = !panel.hidden;
        panel.hidden = wasOpen;
        open.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
        return;
      }
      var close = e.target.closest('.b2b-sample__close');
      if (close) shut(close.closest('.b2b-sample__panel'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.b2b-sample__panel:not([hidden])').forEach(shut);
    });
    // a customer who comes from the link in the pop-up of the product list (?sample=1) finds the sample explanation already open
    function openFromLink() {
      if (!/[?&]sample=1(&|$)/.test(window.location.search)) return;
      var btn = document.querySelector('.b2b-sample__open');
      var panel = btn && btn.closest('.b2b-sample') ? btn.closest('.b2b-sample').querySelector('.b2b-sample__panel') : null;
      if (!panel) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      btn.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromLink); else openFromLink();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["b2b-special-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.b2bSpecialReady) return;
    window.b2bSpecialReady = true;
    var HEAD = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    document.addEventListener('click', function (e) {
      var box = e.target.closest ? e.target.closest('.b2b-so') : null;
      if (!box) return;
      var open = e.target.closest('.b2b-so__open'), step = e.target.closest('.b2b-so__step'), add = e.target.closest('.b2b-so__add');
      var panel = box.querySelector('.b2b-so__panel'), num = box.querySelector('.b2b-so__num');
      if (open) {
        panel.hidden = !panel.hidden;
        open.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      } else if (step) {
        var n = (parseInt(num.value, 10) || 1) + parseInt(step.getAttribute('data-dir'), 10);
        num.value = Math.min(999, Math.max(1, n));
      } else if (add) {
        run(box, add, num, panel);
      }
    });

    // 1. the full box goes into the cart  2. the customer's own code is applied, next to any code that is on the cart already  3. to the cart
    function run(box, btn, num, panel) {
      var qty = Math.min(999, Math.max(1, parseInt(num.value, 10) || 1));
      var msg = box.querySelector('.b2b-so__msg');
      var code = box.getAttribute('data-code');
      msg.textContent = '';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: HEAD, body: JSON.stringify({ items: [{ id: Number(box.getAttribute('data-variant')), quantity: qty }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return c !== code && !/^SW/i.test(c); });   // a store discount code cannot be combined with a special price: this one replaces it
          codes.push(code);
          return fetch('/cart/update.js', { method: 'POST', headers: HEAD, body: JSON.stringify({ discount: codes.join(',') }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('code'); window.location.href = box.getAttribute('data-cart-url') || '/cart'; })
        .catch(function () { msg.textContent = box.getAttribute('data-error') || 'This offer could not be applied.'; btn.disabled = false; });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["b2b-sticky-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.b2bStickyReady) return;
    window.b2bStickyReady = true;
    var bar = null, mainBtn = null, io = null, wired = false;

    function inPage(el) { return el && !(el.closest && el.closest('dialog')); }

    // the real Add to cart button of the product page (not the one of the pop-up)
    function findMain() {
      var all = document.querySelectorAll('product-form-component [ref="addToCartButton"], [ref="addToCartButton"]');
      for (var i = 0; i < all.length; i++) if (inPage(all[i])) return all[i];
      return null;
    }

    // the bar lives directly in the page body, so the theme cannot remove it when it refreshes the product section
    function ensureBar() {
      var found = document.querySelectorAll('[data-b2b-sticky]');
      if (!bar || !bar.isConnected) {
        bar = null;
        for (var i = 0; i < found.length; i++) {
          if (!inPage(found[i])) continue;
          if (found[i].parentElement === document.body) { bar = found[i]; break; }
        }
        if (!bar) {
          for (var j = 0; j < found.length; j++) {
            if (!inPage(found[j])) continue;
            document.body.appendChild(found[j]);
            bar = found[j];
            break;
          }
        }
        wired = false;
      }
      for (var k = 0; k < found.length; k++) if (found[k] !== bar && inPage(found[k])) found[k].remove();
      if (bar && !wired) {
        wired = true;
        bar.querySelector('[data-b2b-sticky-btn]').addEventListener('click', function () {
          if (mainBtn && mainBtn.isConnected && !mainBtn.disabled) mainBtn.click();
        });
      }
    }

    // what the bar says: the chosen packaging with its price, and the same button text and state as the real button
    function refresh() {
      if (!bar) return;
      var sub = bar.querySelector('[data-b2b-sticky-sub]');
      var input = document.querySelector('.b2b-pack input[type="radio"]:checked');
      var label = input ? input.closest('label') : null;
      var text = '';
      if (label) {
        var n = label.querySelector('.b2b-pack__name'), p = label.querySelector('.b2b-pack__price');
        text = [n ? n.textContent.trim() : '', p ? p.textContent.replace(/\s+/g, ' ').trim() : ''].filter(Boolean).join(' · ');
      }
      if (sub && sub.textContent !== text) sub.textContent = text;
      var btn = bar.querySelector('[data-b2b-sticky-btn]');
      if (mainBtn && mainBtn.isConnected && btn) {
        btn.disabled = !!mainBtn.disabled;
        var own = bar.getAttribute('data-button-text');
        var label2 = own || (mainBtn.textContent || '').replace(/\s+/g, ' ').trim();
        if (label2 && btn.textContent !== label2) btn.textContent = label2;
      }
    }

    function setOn(on) {
      if (!bar) return;
      bar.classList.toggle('is-on', on);
      if (on) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); refresh(); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }

    // shown when the real button has gone out of the screen at the top, hidden when it is visible again
    function watch() {
      var m = findMain();
      if (m === mainBtn && io) return;
      if (io) io.disconnect();
      mainBtn = m;
      if (!mainBtn || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        setOn(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      io.observe(mainBtn);
    }

    function init() { ensureBar(); if (bar) watch(); }

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; init(); if (bar && bar.classList.contains('is-on')) refresh(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('change', function () { setTimeout(refresh, 300); });
    document.addEventListener('click', function () { setTimeout(refresh, 400); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
